<div
	class="map"
	id="map"
	#mapRef
	[style.--map-height]="height"
	[style.--map-width]="width"></div>
